<template>
  <layout-public>
    <div class="card card-login">
      <form class="card-stacked" @submit.prevent="authenticate">
        <div class="card-content grey lighten-4">
          <h3>Ingresar al Sistema</h3>
        </div>
        <div class="card-content content-input">
          <div class="input-field">
            <input type="text" v-model="form.ci" id="ci" v-bind:class="{ invalid: errors.ci }">
            <label for="ci" id="label-ci">Cedula</label>
            <span class="helper-text helper-text-error" v-for="(item, index) in errors.ci" :key="index" data-success="right">* {{ item }}</span>
          </div>
          <div class="input-field">
            <input type="password" v-model="form.password" id="password" v-bind:class="{ invalid: errors.password }">
            <label for="password" id="label-password">Clave</label>
            <span class="helper-text helper-text-error" v-for="(item, index) in errors.password" :key="index" data-success="right">* {{ item }}</span>
          </div>
        </div>
        <div class="card-action">
          <button
            class="btn waves-effect waves-light deep-orange darken-2"
            type="submit"
            name="action"
          >
            Ingresar
            <i class="material-icons right">send</i>
          </button>
          <router-link :to="{ name: 'register' }" class="btn-flat transparent grey-text text-darken-3 waves-effect">Registrarse</router-link>
          <!--<button
            class="btn-flat transparent orange-text text-darken-3 waves-effect"
            type="button"
            name="action"
            v-on:click="testDev()"
            v-if="config.APP_DEVMOD"
          >
            Datos de prueba
          </button>-->
        </div>
        <!-- Si desea comprobar la autenticidad de algun documentos emitido por esta herramienta puede hacerlo desde el siguiente enlace. -->
      </form>
    </div>
    <loader :show="loaderStatus"></loader>
  </layout-public>
</template>
<script>
import LayoutPublic from '@/components/layouts/Public'
import { mapState } from 'vuex'
import { login } from '@/helpers/auth'
import Loader from '@/components/Loader'
import config from '@/config.json'
import validate from 'validate.js'

export default {
  data () {
    return {
      config: config,
      loaderStatus: false,
      form: {
        ci: '',
        password: ''
      },
      errors: {
        ci: false,
        password: false
      },
      error: null
    }
  },
  mounted () {
    document.title = 'Ingresar al Sistema'
  },
  components: {
    LayoutPublic,
    Loader
  },
  methods: {
    authenticate () {
      // Validation
      this.errors = {
        ci: false,
        password: false
      }
      const constraints = this.getConstraints()
      const errors = validate(this.form, constraints, {fullMessages: false})
      if (errors) {
        this.errors = errors
        console.log(errors)
        return
      }
      // Login Action
      this.loaderStatus = true
      this.$store.dispatch('login')

      login(this.$data.form)
        .then(res => {
          this.loaderStatus = false
          this.$store.commit('loginSuccess', res)
          this.$router.push({ path: '/' })
        })
        .catch(error => {
          this.loaderStatus = false
          this.$store.commit('loginFailed', { error })
        })
    },
    getConstraints () {
      return {
        ci: {
          presence: {
            message: 'Es requerido',
            allowEmpty: false
          },
          numericality: {
            onlyInteger: true,
            message: 'Solo puede ingresar numeros'
          },
          length: {
            minimum: 6,
            maximum: 8,
            message: function (value, attribute, validatorOptions, attributes, globalOptions) {
              return validate.format('Debe tener entre %{minimum} y %{maximum} digitos', {
                minimum: validatorOptions.minimum,
                maximum: validatorOptions.maximum
              })
            }
          }
        },
        password: {
          presence: {
            message: 'Es requerido',
            allowEmpty: false
          },
          length: {
            minimum: 6,
            message: 'Debe tener un minimo de 6 digitos'
          }
        }
      }
    },
    testDev: function () {
      // this.form.email = 'admin@test.local'
      // this.form.password = 'admin'
      // document.getElementById('label-email').classList.add('active')
      // document.getElementById('label-password').classList.add('active')
    }
  },
  computed: {
    ...mapState(['count']),
    authError () {
      return this.$store.getters.authError
    }
  }
}
</script>
<style lang="scss" scoped>
  .headband {
    padding: 2px 0;
    background-color: #ffffff;
    img {
      max-height: 44px;
    }
    .row {
      margin-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/auth/Login.vue